import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ParameterState {
  contractTypes: Parameter[];
  setContractTypes: (newParameter: Parameter[] | undefined) => void;

  employeeStatus: Parameter[];
  setEmployeeStatus: (newParameter: Parameter[] | undefined) => void;

  isSuportService: Parameter[];
  setIsSuportService: (newParameter: Parameter[] | undefined) => void;

  idDocumentType: Parameter[];
  setIdDocumentType: (newParameter: Parameter[] | undefined) => void;

  maritalStatus: Parameter[];
  setMaritalStatus: (newParameter: Parameter[] | undefined) => void;

  nationality: Parameter[];
  setNationality: (newParameter: Parameter[] | undefined) => void;

  workCountry: Parameter[];
  setWorkCountry: (newParameter: Parameter[] | undefined) => void;

  workLocation: Parameter[];
  setWorkLocation: (newParameter: Parameter[] | undefined) => void;

  workType: Parameter[];
  setWorkType: (newParameter: Parameter[] | undefined) => void;

  timesheetStatus: Parameter[];
  setTimesheetStatus: (newParameter: Parameter[] | undefined) => void;

  invoiceStatus: Parameter[];
  setInvoiceStatus: (newParameter: Parameter[] | undefined) => void;

  projectStatus: Parameter[];
  setProjectStatus: (newParameter: Parameter[] | undefined) => void;

  purchaseOrderStatus: Parameter[];
  setPurchaseOrderStatus: (newParameter: Parameter[] | undefined) => void;

  purchaseOrderType: Parameter[];
  setPurchaseOrderType: (newParameter: Parameter[] | undefined) => void;

  projectRole: Parameter[];
  setProjectRole: (newParameter: Parameter[] | undefined) => void;

  employeeCountry: Parameter[];
  setEmployeeCountry: (newParameter: Parameter[] | undefined) => void;

  projectMemberStatus: Parameter[];
  setProjectMemberStatus: (newParameter: Parameter[] | undefined) => void;

  clientType: Parameter[];
  setClientType: (newParameter: Parameter[] | undefined) => void;

  linkedincardType: Parameter[];
  setLinkedinCardType: (newParameter: Parameter[] | undefined) => void;

  linkedinrequestType: Parameter[];
  setLinkedinRequestType: (newParameter: Parameter[] | undefined) => void;

  tripsheetStatus: Parameter[];
  setTripsheetStatus: (newParameter: Parameter[] | undefined) => void;

  objectType: Parameter[];
  setObjectType: (newParameter: Parameter[] | undefined) => void;

  documentType: Parameter[];
  setDocumentType: (newParameter: Parameter[] | undefined) => void;

  distanceType: Parameter[];
  setDistanceType: (newParameter: Parameter[] | undefined) => void;

  supportTripStatus: Parameter[];
  setSupportTripStatus: (newParameter: Parameter[] | undefined) => void;

  expenseType: Parameter[];
  setExpenseType: (newParameter: Parameter[] | undefined) => void;

  maxVacationDaysNextYear: Parameter[];
  setMaxVacationDaysNextYear: (newParameter: Parameter[] | undefined) => void;
}

export const useParameterStore = create<ParameterState>()(
  devtools(
    (set) => ({
      contractTypes: [],
      setContractTypes: (newParameter) =>
        set(() => ({
          contractTypes: newParameter ? [...newParameter] : [],
        })),

      employeeStatus: [],
      setEmployeeStatus: (newParameter) =>
        set(() => ({
          employeeStatus: newParameter ? [...newParameter] : [],
        })),

      isSuportService: [],
      setIsSuportService: (newParameter) =>
        set(() => ({
          isSuportService: newParameter ? [...newParameter] : [],
        })),

      idDocumentType: [],
      setIdDocumentType: (newParameter) =>
        set(() => ({
          idDocumentType: newParameter ? [...newParameter] : [],
        })),

      maritalStatus: [],
      setMaritalStatus: (newParameter) =>
        set(() => ({
          maritalStatus: newParameter ? [...newParameter] : [],
        })),

      timesheetStatus: [],
      setTimesheetStatus: (newParameter) =>
        set(() => ({
          timesheetStatus: newParameter ? [...newParameter] : [],
        })),

      invoiceStatus: [],
      setInvoiceStatus: (newParameter) =>
        set(() => ({
          invoiceStatus: newParameter ? [...newParameter] : [],
        })),

      projectStatus: [],
      setProjectStatus: (newParameter) =>
        set(() => ({
          projectStatus: newParameter ? [...newParameter] : [],
        })),

      purchaseOrderStatus: [],
      setPurchaseOrderStatus: (newParameter) =>
        set(() => ({
          purchaseOrderStatus: newParameter ? [...newParameter] : [],
        })),

      purchaseOrderType: [],
      setPurchaseOrderType: (newParameter) =>
        set(() => ({
          purchaseOrderType: newParameter ? [...newParameter] : [],
        })),

      nationality: [],
      setNationality: (newParameter) =>
        set(() => ({
          nationality: newParameter ? [...newParameter] : [],
        })),

      workCountry: [],
      setWorkCountry: (newParameter) =>
        set(() => ({
          workCountry: newParameter ? [...newParameter] : [],
        })),

      workLocation: [],
      setWorkLocation: (newParameter) =>
        set(() => ({
          workLocation: newParameter ? [...newParameter] : [],
        })),

      workType: [],
      setWorkType: (newParameter) =>
        set(() => ({
          workType: newParameter ? [...newParameter] : [],
        })),

      projectRole: [],
      setProjectRole: (newParameter) =>
        set(() => ({
          projectRole: newParameter ? [...newParameter] : [],
        })),

      employeeCountry: [],
      setEmployeeCountry: (newParameter) =>
        set(() => ({
          employeeCountry: newParameter ? [...newParameter] : [],
        })),

      projectMemberStatus: [],
      setProjectMemberStatus: (newParameter) =>
        set(() => ({
          projectMemberStatus: newParameter ? [...newParameter] : [],
        })),

      clientType: [],
      setClientType: (newParameter) =>
        set(() => ({
          clientType: newParameter ? [...newParameter] : [],
        })),

      linkedincardType: [],
      setLinkedinCardType: (newParameter) =>
        set(() => ({
          linkedincardType: newParameter ? [...newParameter] : [],
        })),

      linkedinrequestType: [],
      setLinkedinRequestType: (newParameter) =>
        set(() => ({
          linkedinrequestType: newParameter ? [...newParameter] : [],
        })),


      tripsheetStatus: [],
      setTripsheetStatus: (newParameter) =>
        set(() => ({
          tripsheetStatus: newParameter ? [...newParameter] : [],
        })),

      objectType: [],
      setObjectType: (newParameter) =>
        set(() => ({
          objectType: newParameter ? [...newParameter] : [],
        })),

      documentType: [],
      setDocumentType: (newParameter) =>
        set(() => ({
          documentType: newParameter ? [...newParameter] : [],
        })),

      distanceType: [],
      setDistanceType: (newParameter) =>
        set(() => ({
          distanceType: newParameter ? [...newParameter] : [],
        })),

      supportTripStatus: [],
      setSupportTripStatus: (newParameter) =>
        set(() => ({
          supportTripStatus: newParameter ? [...newParameter] : [],
        })),

      expenseType: [],
      setExpenseType: (newParameter) =>
        set(() => ({
          expenseType: newParameter ? [...newParameter] : [],
        })),

      maxVacationDaysNextYear: [],
      setMaxVacationDaysNextYear: (newParameter) =>
        set(() => ({
          maxVacationDaysNextYear: newParameter ? [...newParameter] : [],
        })),
    }),
    { name: "ParameterStore" }
  )
);
